const listings = [
  {
    id: 1,
    role: "Full Stack Engineer",
    positionType: "FULL-TIME",
    minCtc: 400000,
    maxCtc: 750000,
    eligibilityIds: [70],
    coursesAllowed: "B.Tech All Branches",
    jobDescription:
      "<h1>This is a rich job description</h1><h3>Job Responsibilities</h3><h3><br></h3><ul><li>Perform your duties.</li><li>Be punctual.</li><li>Be Professional</li></ul>",
    jobDescriptionPdfLink:
      "https://flashpact-public.s3.ap-south-1.amazonaws.com/demo/job_description.pdf",
    careerPageApplicationLink: "",
    instituteIds: [1],
    stageIds: [3],
    companyId: 2,
    listerIds: [1],
    deadline: "2023-10-30T18:30:00.000Z",
    status: "ACTIVE",
    questionIds: [2, 3],
    startTakingApplicationsAt: "2023-10-03T00:30:00.000Z",
    createdAt: "2023-10-03T17:56:06.161Z",
    updatedAt: "2023-10-23T16:41:20.632Z",
    instituteDetails: [
      {
        id: 1,
        name: "Flash Pact University",
        pincode: 560035,
        address: "Flash Street, Bengaluru",
        type: "COLLEGE",
        about: "Education and degrees in a flash",
        site: "www.flashpact.in",
        logo: null,
        userId: 1,
        listingIds: [1, 2, 1, 1, 1, 1, 1, 1],
        createdAt: "2023-10-03T15:00:57.724Z",
        updatedAt: "2023-10-23T16:41:20.704Z",
      },
    ],
    stageDetails: [
      {
        id: 3,
        name: "11",
        description: "11",
        scheduledAt: "2023-10-03T20:30:00.000Z",
        venue: "",
        createdAt: "2023-10-03T17:53:25.055Z",
        updatedAt: "2023-10-03T17:53:25.055Z",
      },
    ],
    companyDetails: {
      id: 2,
      name: "Dime Shifter Services",
      site: "www.dimeshifter.com",
      about: "Shifting Dimes",
      listingIds: [1, 1, 1, 1, 1, 1, 1],
      logo: null,
      createdAt: "2023-10-03T17:53:31.708Z",
      updatedAt: "2023-10-23T16:41:20.706Z",
    },
    listerDetails: [
      {
        id: 1,
        name: "John Doe",
        dateOfBirth: "1990-01-15",
        gender: "Male",
        password: "",
        email: "roopesh@flashpact.in",
        phone: "12345678901112",
        role: "TPO",
        active: true,
        profilePicture: null,
        permissions: {
          LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
          USER: ["CREATE", "READ", "UPDATE", "DELETE"],
          INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
          COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
          ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
        },
        createdAt: "2023-10-03T11:08:28.614Z",
        updatedAt: "2023-10-22T15:53:17.956Z",
      },
    ],
    questionDetails: [
      {
        id: 2,
        text: "Can you please provide a response to this question, considering that it's quite long and contains 20 sentences?",
        createdAt: "2023-10-03T17:36:03.379Z",
        updatedAt: "2023-10-03T17:36:03.379Z",
      },
      {
        id: 3,
        text: "This is now some question?\n",
        createdAt: "2023-10-03T17:53:43.971Z",
        updatedAt: "2023-10-03T17:53:43.971Z",
      },
    ],
    eligibilityDetails: [
      {
        id: 70,
        context: "GRADE 10",
        value: 1,
        createdAt: "2023-10-03T17:53:11.289Z",
        updatedAt: "2023-10-03T17:53:11.289Z",
      },
    ],
  },
  {
    id: 2,
    role: "Software Developer",
    positionType: "FULL-TIME",
    minCtc: 1000000,
    maxCtc: 2000000,
    eligibilityIds: [75, 76, 77],
    coursesAllowed: "B.Tech CSE",
    jobDescription: null,
    jobDescriptionPdfLink: null,
    careerPageApplicationLink: "",
    instituteIds: [1],
    stageIds: [15],
    companyId: 3,
    listerIds: [1],
    deadline: "2023-10-12T18:30:00.000Z",
    status: "ACTIVE",
    questionIds: null,
    startTakingApplicationsAt: "2023-10-09T18:30:00.000Z",
    createdAt: "2023-10-05T15:51:45.678Z",
    updatedAt: "2023-10-05T15:51:45.678Z",
    instituteDetails: [
      {
        id: 1,
        name: "Flash Pact University",
        pincode: 560035,
        address: "Flash Street, Bengaluru",
        type: "COLLEGE",
        about: "Education and degrees in a flash",
        site: "www.flashpact.in",
        logo: null,
        userId: 1,
        listingIds: [1, 2, 1, 1, 1, 1, 1, 1],
        createdAt: "2023-10-03T15:00:57.724Z",
        updatedAt: "2023-10-23T16:41:20.704Z",
      },
    ],
    stageDetails: [
      {
        id: 15,
        name: "Coding Test",
        description: "Coding Test",
        scheduledAt: "2023-10-05T00:30:00.000Z",
        venue: "Online",
        createdAt: "2023-10-05T15:51:04.108Z",
        updatedAt: "2023-10-05T15:51:04.108Z",
      },
    ],
    companyDetails: {
      id: 3,
      name: "Flashpact",
      site: "www.flashpact.in",
      about: "Do things in a flash",
      listingIds: [2],
      logo: null,
      createdAt: "2023-10-05T15:51:19.615Z",
      updatedAt: "2023-10-05T15:51:45.791Z",
    },
    listerDetails: [
      {
        id: 1,
        name: "John Doe",
        dateOfBirth: "1990-01-15",
        gender: "Male",
        password: "",
        email: "roopesh@flashpact.in",
        phone: "12345678901112",
        role: "TPO",
        active: true,
        profilePicture: null,
        permissions: {
          LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
          USER: ["CREATE", "READ", "UPDATE", "DELETE"],
          INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
          COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
          ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
        },
        createdAt: "2023-10-03T11:08:28.614Z",
        updatedAt: "2023-10-22T15:53:17.956Z",
      },
    ],
    eligibilityDetails: [
      {
        id: 75,
        context: "GRADE 10",
        value: 60,
        createdAt: "2023-10-05T15:50:24.800Z",
        updatedAt: "2023-10-05T15:50:24.800Z",
      },
      {
        id: 76,
        context: "GRADE 12",
        value: 75,
        createdAt: "2023-10-05T15:50:30.432Z",
        updatedAt: "2023-10-05T15:50:30.432Z",
      },
      {
        id: 77,
        context: "BACHELORS",
        value: 70,
        createdAt: "2023-10-05T15:50:35.940Z",
        updatedAt: "2023-10-05T15:50:35.940Z",
      },
    ],
  },
];

const user = {
  id: 20,
  name: "Ramesh Suresh",
  dateOfBirth: null,
  gender: "FEMALE",
  email: "samuel.martinez@example.com",
  phone: "9876543210",
  role: "TPO",
  active: true,
  profilePicture: null,
  createdAt: "2023-10-18T15:05:39.017Z",
  updatedAt: "2023-10-22T10:44:46.030Z",
  aspirantId: -1,
  token: "abc",
  instituteId: -1,
};

const listing = JSON.parse(
  '{"id":2,"role":"Software Developer","positionType":"FULL-TIME","minCtc":1000000,"maxCtc":2000000,"eligibilityIds":[75,76,77],"coursesAllowed":"B.tech Cse","jobDescription":null,"jobDescriptionPdfLink":null,"careerPageApplicationLink":"","instituteIds":[1],"stageIds":[15],"companyId":3,"listerIds":[1],"deadline":"2023-10-12T18:30:00.000Z","status":"ACTIVE","questionIds":null,"startTakingApplicationsAt":"2023-10-09T18:30:00.000Z","createdAt":"2023-10-05T15:51:45.678Z","updatedAt":"2023-10-05T15:51:45.678Z","instituteDetails":[{"id":1,"name":"This is the first Institute","pincode":111,"address":"111","type":"COLLEGE","about":"11","site":"11","logo":null,"userId":1,"listingIds":[1,2,1,1,1,1],"createdAt":"2023-10-03T15:00:57.724Z","updatedAt":"2023-10-12T16:41:49.950Z"}],"stageDetails":[{"id":15,"name":"Coding Test","description":"Coding Test","scheduledAt":"2023-10-05T00:30:00.000Z","venue":"Online","createdAt":"2023-10-05T15:51:04.108Z","updatedAt":"2023-10-05T15:51:04.108Z"}],"companyDetails":{"id":3,"name":"Flashpact","site":"www.flashpact.in","about":"Do things in a flash","listingIds":[2],"logo":null,"createdAt":"2023-10-05T15:51:19.615Z","updatedAt":"2023-10-05T15:51:45.791Z"},"listerDetails":[{"id":1,"name":"John Doe","dateOfBirth":"1990-01-15","gender":"Male","password":"","email":"roopesh@flashpact.in","phone":"12345678901112","role":"TPO","active":true,"profilePicture":null,"permissions":{"LISTING":["CREATE","READ","UPDATE","DELETE"],"USER":["CREATE","READ","UPDATE","DELETE"],"INSTITUTE":["CREATE","READ","UPDATE","DELETE"],"COMPANY":["CREATE","READ","UPDATE","DELETE"],"ASPIRANT":["CREATE","READ","UPDATE","DELETE"]},"createdAt":"2023-10-03T11:08:28.614Z","updatedAt":"2023-10-22T12:00:18.635Z"}],"eligibilityDetails":[{"id":75,"context":"GRADE 10","value":60,"createdAt":"2023-10-05T15:50:24.800Z","updatedAt":"2023-10-05T15:50:24.800Z"},{"id":76,"context":"GRADE 12","value":75,"createdAt":"2023-10-05T15:50:30.432Z","updatedAt":"2023-10-05T15:50:30.432Z"},{"id":77,"context":"BACHELORS","value":70,"createdAt":"2023-10-05T15:50:35.940Z","updatedAt":"2023-10-05T15:50:35.940Z"}]}'
);

const application = {
  id: 4,
  listingId: 1,
  aspirantId: 11,
  currentStageId: 3,
  status: "OFFER ACCEPTED",
  offerExpiry: "2023-10-25T18:30:00.000Z",
  offerLetter:
    "https://flashpact-public.s3.ap-south-1.amazonaws.com/demo/offer-letter-format.pdf",
  createdAt: "2023-10-22T07:29:54.831Z",
  updatedAt: "2023-10-22T16:48:08.275Z",
  currentStageDetails: {
    id: 3,
    name: "Bar Raiser Round",
    description:
      "A comprehensive interview with the tech lead and managing director",
    scheduledAt: "2023-10-03T20:30:00.000Z",
    venue: "",
    createdAt: "2023-10-03T17:53:25.055Z",
    updatedAt: "2023-10-03T17:53:25.055Z",
  },
  listingDetails: {
    id: 1,
    role: "dsfsf",
    positionType: "FULL-TIME",
    minCtc: 1,
    maxCtc: 2,
    eligibilityIds: [70],
    coursesAllowed: "111",
    jobDescription:
      "<h1>This is a rich job description</h1><h1><br></h1><h3>I can't believe I implemented this shit</h3><h3><br></h3><p>This is insane.</p>",
    jobDescriptionPdfLink: null,
    careerPageApplicationLink: "",
    instituteIds: [1],
    stageIds: [3],
    companyId: 2,
    listerIds: [1],
    deadline: "2023-10-09T18:30:00.000Z",
    status: "ACTIVE",
    questionIds: [2, 3],
    startTakingApplicationsAt: "2023-10-03T00:30:00.000Z",
    createdAt: "2023-10-03T17:56:06.161Z",
    updatedAt: "2023-10-12T16:41:49.886Z",
    instituteDetails: [
      {
        id: 1,
        name: "This is the first Institute",
        pincode: 111,
        address: "111",
        type: "COLLEGE",
        about: "11",
        site: "11",
        logo: null,
        userId: 1,
        listingIds: [1, 2, 1, 1, 1, 1],
        createdAt: "2023-10-03T15:00:57.724Z",
        updatedAt: "2023-10-12T16:41:49.950Z",
      },
    ],
    stageDetails: [
      {
        id: 3,
        name: "11",
        description: "11",
        scheduledAt: "2023-10-03T20:30:00.000Z",
        venue: "",
        createdAt: "2023-10-03T17:53:25.055Z",
        updatedAt: "2023-10-03T17:53:25.055Z",
      },
    ],
    companyDetails: {
      id: 2,
      name: "11",
      site: "11",
      about: "11",
      listingIds: [1, 1, 1, 1, 1],
      logo: null,
      createdAt: "2023-10-03T17:53:31.708Z",
      updatedAt: "2023-10-12T16:41:49.951Z",
    },
    listerDetails: [
      {
        id: 1,
        name: "John Doe",
        dateOfBirth: "1990-01-15",
        gender: "Male",
        password: "",
        email: "roopesh@flashpact.in",
        phone: "12345678901112",
        role: "TPO",
        active: true,
        profilePicture: null,
        permissions: {
          LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
          USER: ["CREATE", "READ", "UPDATE", "DELETE"],
          INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
          COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
          ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
        },
        createdAt: "2023-10-03T11:08:28.614Z",
        updatedAt: "2023-10-22T15:53:17.956Z",
      },
    ],
    questionDetails: [
      {
        id: 2,
        text: "Can you please provide a response to this question, considering that it's quite long and contains 20 sentences?",
        createdAt: "2023-10-03T17:36:03.379Z",
        updatedAt: "2023-10-03T17:36:03.379Z",
      },
      {
        id: 3,
        text: "This is now some question?\n",
        createdAt: "2023-10-03T17:53:43.971Z",
        updatedAt: "2023-10-03T17:53:43.971Z",
      },
    ],
    eligibilityDetails: [
      {
        id: 70,
        context: "GRADE 10",
        value: 1,
        createdAt: "2023-10-03T17:53:11.289Z",
        updatedAt: "2023-10-03T17:53:11.289Z",
      },
    ],
  },
  aspirantDetails: {
    id: 11,
    userId: 20,
    instituteId: 1,
    rollNo: "10",
    resume: "Resume 10",
    degree: "",
    branch: "",
    gradeIds: [28, 29],
    documents: [],
    allowedForPlacement: true,
    createdAt: "2023-10-18T15:05:42.589Z",
    updatedAt: "2023-10-22T07:27:55.488Z",
  },
  userDetails: {
    id: 20,
    name: "Samuel Martinez",
    dateOfBirth: null,
    gender: "FEMALE",
    password: "",
    email: "samuel.martinez@example.com",
    phone: "110",
    role: "ASPIRANT",
    active: true,
    profilePicture: null,
    permissions: null,
    createdAt: "2023-10-18T15:05:39.017Z",
    updatedAt: "2023-10-22T10:44:46.030Z",
  },
};

const aspirants = [
  {
    id: 1,
    status: "APPLIED",
    offerExpiry: null,
    offerLetter:
      "https://flashpact-public.s3.ap-south-1.amazonaws.com/demo/offer-letter-format.pdf",
    name: "Susan Williams",
    email: "susan@example.com",
    "stage-name": "Bar Raiser",
    "stage-scheduledAt": "2023-10-03T20:30:00.000Z",
  },
  {
    id: 4,
    status: "OFFERED",
    offerExpiry: "2023-10-25T18:30:00.000Z",
    offerLetter:
      "https://flashpact-public.s3.ap-south-1.amazonaws.com/demo/offer-letter-format.pdf",
    name: "Samuel Martinez",
    email: "samuel.martinez@example.com",
    "stage-name": "Coding Test",
    "stage-scheduledAt": "2023-10-03T20:30:00.000Z",
  },
];

const calendarEvents = [
  {
    start: "2023-11-04T18:30:00.000Z",
    end: "2023-11-10T11:30:00.000Z",
    title: "Instagram - Business Analyst",
    description: null,
    listingId: 4,
    listingDetails: {
      id: 4,
      role: "Business Analyst",
      positionType: "FULL-TIME",
      minCtc: 500000,
      maxCtc: 850000,
      eligibilityIds: null,
      coursesAllowed: "",
      jobDescription: null,
      jobDescriptionPdfLink: null,
      careerPageApplicationLink: "",
      instituteIds: [1],
      stageIds: null,
      companyId: 7,
      listerIds: [1],
      deadline: "2023-11-10T11:30:00.000Z",
      status: "ACTIVE",
      questionIds: null,
      startTakingApplicationsAt: "2023-11-04T18:30:00.000Z",
      createdAt: "2023-11-05T08:59:35.432Z",
      updatedAt: "2023-11-05T08:59:35.432Z",
      instituteDetails: [
        {
          id: 1,
          name: "Flash Pact University",
          pincode: 560035,
          address: "Flash Street, Bengaluru",
          type: "COLLEGE",
          about: "Education and degrees in a flash",
          site: "www.flashpact.in",
          logo: null,
          userId: 1,
          listingIds: [1, 2, 1, 1, 1, 1, 1, 1, 3, 3, 4],
          createdAt: "2023-10-03T15:00:57.724Z",
          updatedAt: "2023-11-05T08:59:35.507Z",
          listingDetails: [
            {
              id: 2,
              role: "Software Developer",
              positionType: "FULL-TIME",
              minCtc: 1000000,
              maxCtc: 2000000,
              eligibilityIds: [75, 76, 77],
              coursesAllowed: "B.Tech CSE",
              jobDescription: null,
              jobDescriptionPdfLink: null,
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: [15],
              companyId: 3,
              listerIds: [1],
              deadline: "2023-10-12T18:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-10-09T18:30:00.000Z",
              createdAt: "2023-10-05T15:51:45.678Z",
              updatedAt: "2023-10-05T15:51:45.678Z",
            },
            {
              id: 1,
              role: "Full Stack Engineer",
              positionType: "FULL-TIME",
              minCtc: 400000,
              maxCtc: 750000,
              eligibilityIds: [70],
              coursesAllowed: "B.Tech All Branches",
              jobDescription:
                "<h1>This is a rich job description</h1><h3>Job Responsibilities</h3><h3><br></h3><ul><li>Perform your duties.</li><li>Be punctual.</li><li>Be Professional</li></ul>",
              jobDescriptionPdfLink:
                "https://flashpact-public.s3.ap-south-1.amazonaws.com/listings/job_description/1698078962670__Business_Card.pdf",
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: [3],
              companyId: 2,
              listerIds: [1],
              deadline: "2023-10-30T18:30:00.000Z",
              status: "ACTIVE",
              questionIds: [2, 3],
              startTakingApplicationsAt: "2023-10-03T00:30:00.000Z",
              createdAt: "2023-10-03T17:56:06.161Z",
              updatedAt: "2023-10-23T16:41:20.632Z",
            },
            {
              id: 4,
              role: "Business Analyst",
              positionType: "FULL-TIME",
              minCtc: 500000,
              maxCtc: 850000,
              eligibilityIds: null,
              coursesAllowed: "",
              jobDescription: null,
              jobDescriptionPdfLink: null,
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: null,
              companyId: 7,
              listerIds: [1],
              deadline: "2023-11-05T11:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-11-04T18:30:00.000Z",
              createdAt: "2023-11-05T08:59:35.432Z",
              updatedAt: "2023-11-05T08:59:35.432Z",
            },
            {
              id: 3,
              role: "SDE III",
              positionType: "FULL-TIME",
              minCtc: 10000000,
              maxCtc: 20000000,
              eligibilityIds: null,
              coursesAllowed: "",
              jobDescription: null,
              jobDescriptionPdfLink:
                "https://flashpact-public.s3.ap-south-1.amazonaws.com/listings/job_description/1698138952569__job_description.pdf",
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: null,
              companyId: 5,
              listerIds: [1],
              deadline: "2023-10-23T23:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-10-31T18:30:00.000Z",
              createdAt: "2023-10-24T09:15:53.127Z",
              updatedAt: "2023-11-05T08:58:02.244Z",
            },
          ],
          userDetails: {
            id: 1,
            name: "John Doe",
            dateOfBirth: "1990-01-15",
            gender: "Male",
            password: "",
            email: "roopesh@flashpact.in",
            phone: "12345678901112",
            role: "TPO",
            active: true,
            profilePicture: null,
            permissions: {
              LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
              USER: ["CREATE", "READ", "UPDATE", "DELETE"],
              INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
              COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
              ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
            },
            createdAt: "2023-10-03T11:08:28.614Z",
            updatedAt: "2023-10-22T15:53:17.956Z",
          },
        },
      ],
      companyDetails: {
        id: 7,
        name: "Instagram",
        site: "",
        about: "",
        listingIds: [4],
        logo: null,
        createdAt: "2023-11-05T08:59:09.210Z",
        updatedAt: "2023-11-05T08:59:35.509Z",
        listingDetails: [
          {
            id: 4,
            role: "Business Analyst",
            positionType: "FULL-TIME",
            minCtc: 500000,
            maxCtc: 850000,
            eligibilityIds: null,
            coursesAllowed: "",
            jobDescription: null,
            jobDescriptionPdfLink: null,
            careerPageApplicationLink: "",
            instituteIds: [1],
            stageIds: null,
            companyId: 7,
            listerIds: [1],
            deadline: "2023-11-05T11:30:00.000Z",
            status: "ACTIVE",
            questionIds: null,
            startTakingApplicationsAt: "2023-11-04T18:30:00.000Z",
            createdAt: "2023-11-05T08:59:35.432Z",
            updatedAt: "2023-11-05T08:59:35.432Z",
          },
        ],
      },
      listerDetails: [
        {
          id: 1,
          name: "John Doe",
          dateOfBirth: "1990-01-15",
          gender: "Male",
          password: "",
          email: "roopesh@flashpact.in",
          phone: "12345678901112",
          role: "TPO",
          active: true,
          profilePicture: null,
          permissions: {
            LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
            USER: ["CREATE", "READ", "UPDATE", "DELETE"],
            INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
            COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
            ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
          },
          createdAt: "2023-10-03T11:08:28.614Z",
          updatedAt: "2023-10-22T15:53:17.956Z",
        },
      ],
    },
  },
  {
    start: "2023-11-09T18:30:00.000Z",
    end: "2023-11-12T18:30:00.000Z",
    title: "Flashpact - Software Developer",
    description: null,
    listingId: 2,
    listingDetails: {
      id: 2,
      role: "Software Developer",
      positionType: "FULL-TIME",
      minCtc: 1000000,
      maxCtc: 2000000,
      eligibilityIds: [75, 76, 77],
      coursesAllowed: "B.Tech CSE",
      jobDescription: null,
      jobDescriptionPdfLink: null,
      careerPageApplicationLink: "",
      instituteIds: [1],
      stageIds: [15],
      companyId: 3,
      listerIds: [1],
      deadline: "2023-11-12T18:30:00.000Z",
      status: "ACTIVE",
      questionIds: null,
      startTakingApplicationsAt: "2023-11-09T18:30:00.000Z",
      createdAt: "2023-10-05T15:51:45.678Z",
      updatedAt: "2023-10-05T15:51:45.678Z",
      instituteDetails: [
        {
          id: 1,
          name: "Flash Pact University",
          pincode: 560035,
          address: "Flash Street, Bengaluru",
          type: "COLLEGE",
          about: "Education and degrees in a flash",
          site: "www.flashpact.in",
          logo: null,
          userId: 1,
          listingIds: [1, 2, 1, 1, 1, 1, 1, 1, 3, 3, 4],
          createdAt: "2023-10-03T15:00:57.724Z",
          updatedAt: "2023-11-05T08:59:35.507Z",
          listingDetails: [
            {
              id: 2,
              role: "Software Developer",
              positionType: "FULL-TIME",
              minCtc: 1000000,
              maxCtc: 2000000,
              eligibilityIds: [75, 76, 77],
              coursesAllowed: "B.Tech CSE",
              jobDescription: null,
              jobDescriptionPdfLink: null,
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: [15],
              companyId: 3,
              listerIds: [1],
              deadline: "2023-10-12T18:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-10-09T18:30:00.000Z",
              createdAt: "2023-10-05T15:51:45.678Z",
              updatedAt: "2023-10-05T15:51:45.678Z",
            },
            {
              id: 1,
              role: "Full Stack Engineer",
              positionType: "FULL-TIME",
              minCtc: 400000,
              maxCtc: 750000,
              eligibilityIds: [70],
              coursesAllowed: "B.Tech All Branches",
              jobDescription:
                "<h1>This is a rich job description</h1><h3>Job Responsibilities</h3><h3><br></h3><ul><li>Perform your duties.</li><li>Be punctual.</li><li>Be Professional</li></ul>",
              jobDescriptionPdfLink:
                "https://flashpact-public.s3.ap-south-1.amazonaws.com/listings/job_description/1698078962670__Business_Card.pdf",
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: [3],
              companyId: 2,
              listerIds: [1],
              deadline: "2023-10-30T18:30:00.000Z",
              status: "ACTIVE",
              questionIds: [2, 3],
              startTakingApplicationsAt: "2023-10-03T00:30:00.000Z",
              createdAt: "2023-10-03T17:56:06.161Z",
              updatedAt: "2023-10-23T16:41:20.632Z",
            },
            {
              id: 4,
              role: "Business Analyst",
              positionType: "FULL-TIME",
              minCtc: 500000,
              maxCtc: 850000,
              eligibilityIds: null,
              coursesAllowed: "",
              jobDescription: null,
              jobDescriptionPdfLink: null,
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: null,
              companyId: 7,
              listerIds: [1],
              deadline: "2023-11-05T11:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-11-04T18:30:00.000Z",
              createdAt: "2023-11-05T08:59:35.432Z",
              updatedAt: "2023-11-05T08:59:35.432Z",
            },
            {
              id: 3,
              role: "SDE III",
              positionType: "FULL-TIME",
              minCtc: 10000000,
              maxCtc: 20000000,
              eligibilityIds: null,
              coursesAllowed: "",
              jobDescription: null,
              jobDescriptionPdfLink:
                "https://flashpact-public.s3.ap-south-1.amazonaws.com/listings/job_description/1698138952569__job_description.pdf",
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: null,
              companyId: 5,
              listerIds: [1],
              deadline: "2023-10-23T23:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-10-31T18:30:00.000Z",
              createdAt: "2023-10-24T09:15:53.127Z",
              updatedAt: "2023-11-05T08:58:02.244Z",
            },
          ],
          userDetails: {
            id: 1,
            name: "John Doe",
            dateOfBirth: "1990-01-15",
            gender: "Male",
            password: "",
            email: "roopesh@flashpact.in",
            phone: "12345678901112",
            role: "TPO",
            active: true,
            profilePicture: null,
            permissions: {
              LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
              USER: ["CREATE", "READ", "UPDATE", "DELETE"],
              INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
              COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
              ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
            },
            createdAt: "2023-10-03T11:08:28.614Z",
            updatedAt: "2023-10-22T15:53:17.956Z",
          },
        },
      ],
      stageDetails: [
        {
          id: 15,
          name: "Coding Test",
          description: "Coding Test",
          scheduledAt: "2023-10-05T00:30:00.000Z",
          venue: "Online",
          createdAt: "2023-10-05T15:51:04.108Z",
          updatedAt: "2023-10-05T15:51:04.108Z",
        },
      ],
      companyDetails: {
        id: 3,
        name: "Flashpact",
        site: "www.flashpact.in",
        about: "Do things in a flash",
        listingIds: [2],
        logo: null,
        createdAt: "2023-10-05T15:51:19.615Z",
        updatedAt: "2023-10-05T15:51:45.791Z",
        listingDetails: [
          {
            id: 2,
            role: "Software Developer",
            positionType: "FULL-TIME",
            minCtc: 1000000,
            maxCtc: 2000000,
            eligibilityIds: [75, 76, 77],
            coursesAllowed: "B.Tech CSE",
            jobDescription: null,
            jobDescriptionPdfLink: null,
            careerPageApplicationLink: "",
            instituteIds: [1],
            stageIds: [15],
            companyId: 3,
            listerIds: [1],
            deadline: "2023-10-12T18:30:00.000Z",
            status: "ACTIVE",
            questionIds: null,
            startTakingApplicationsAt: "2023-10-09T18:30:00.000Z",
            createdAt: "2023-10-05T15:51:45.678Z",
            updatedAt: "2023-10-05T15:51:45.678Z",
          },
        ],
      },
      listerDetails: [
        {
          id: 1,
          name: "John Doe",
          dateOfBirth: "1990-01-15",
          gender: "Male",
          password: "",
          email: "roopesh@flashpact.in",
          phone: "12345678901112",
          role: "TPO",
          active: true,
          profilePicture: null,
          permissions: {
            LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
            USER: ["CREATE", "READ", "UPDATE", "DELETE"],
            INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
            COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
            ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
          },
          createdAt: "2023-10-03T11:08:28.614Z",
          updatedAt: "2023-10-22T15:53:17.956Z",
        },
      ],
      eligibilityDetails: [
        {
          id: 75,
          context: "GRADE 10",
          value: 60,
          createdAt: "2023-10-05T15:50:24.800Z",
          updatedAt: "2023-10-05T15:50:24.800Z",
        },
        {
          id: 76,
          context: "GRADE 12",
          value: 75,
          createdAt: "2023-10-05T15:50:30.432Z",
          updatedAt: "2023-10-05T15:50:30.432Z",
        },
        {
          id: 77,
          context: "BACHELORS",
          value: 70,
          createdAt: "2023-10-05T15:50:35.940Z",
          updatedAt: "2023-10-05T15:50:35.940Z",
        },
      ],
    },
  },
  {
    start: "2023-11-03T00:30:00.000Z",
    end: "2023-11-30T18:30:00.000Z",
    title: "Dime Shifter Services - Full Stack Engineer",
    description:
      "<h1>This is a rich job description</h1><h3>Job Responsibilities</h3><h3><br></h3><ul><li>Perform your duties.</li><li>Be punctual.</li><li>Be Professional</li></ul>",
    listingId: 1,
    listingDetails: {
      id: 1,
      role: "Full Stack Engineer",
      positionType: "FULL-TIME",
      minCtc: 400000,
      maxCtc: 750000,
      eligibilityIds: [70],
      coursesAllowed: "B.Tech All Branches",
      jobDescription:
        "<h1>This is a rich job description</h1><h3>Job Responsibilities</h3><h3><br></h3><ul><li>Perform your duties.</li><li>Be punctual.</li><li>Be Professional</li></ul>",
      jobDescriptionPdfLink:
        "https://flashpact-public.s3.ap-south-1.amazonaws.com/listings/job_description/1698078962670__Business_Card.pdf",
      careerPageApplicationLink: "",
      instituteIds: [1],
      stageIds: [3],
      companyId: 2,
      listerIds: [1],
      deadline: "2023-11-30T18:30:00.000Z",
      status: "ACTIVE",
      questionIds: [2, 3],
      startTakingApplicationsAt: "2023-11-03T00:30:00.000Z",
      createdAt: "2023-10-03T17:56:06.161Z",
      updatedAt: "2023-10-23T16:41:20.632Z",
      instituteDetails: [
        {
          id: 1,
          name: "Flash Pact University",
          pincode: 560035,
          address: "Flash Street, Bengaluru",
          type: "COLLEGE",
          about: "Education and degrees in a flash",
          site: "www.flashpact.in",
          logo: null,
          userId: 1,
          listingIds: [1, 2, 1, 1, 1, 1, 1, 1, 3, 3, 4],
          createdAt: "2023-10-03T15:00:57.724Z",
          updatedAt: "2023-11-05T08:59:35.507Z",
          listingDetails: [
            {
              id: 2,
              role: "Software Developer",
              positionType: "FULL-TIME",
              minCtc: 1000000,
              maxCtc: 2000000,
              eligibilityIds: [75, 76, 77],
              coursesAllowed: "B.Tech CSE",
              jobDescription: null,
              jobDescriptionPdfLink: null,
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: [15],
              companyId: 3,
              listerIds: [1],
              deadline: "2023-10-12T18:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-10-09T18:30:00.000Z",
              createdAt: "2023-10-05T15:51:45.678Z",
              updatedAt: "2023-10-05T15:51:45.678Z",
            },
            {
              id: 1,
              role: "Full Stack Engineer",
              positionType: "FULL-TIME",
              minCtc: 400000,
              maxCtc: 750000,
              eligibilityIds: [70],
              coursesAllowed: "B.Tech All Branches",
              jobDescription:
                "<h1>This is a rich job description</h1><h3>Job Responsibilities</h3><h3><br></h3><ul><li>Perform your duties.</li><li>Be punctual.</li><li>Be Professional</li></ul>",
              jobDescriptionPdfLink:
                "https://flashpact-public.s3.ap-south-1.amazonaws.com/listings/job_description/1698078962670__Business_Card.pdf",
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: [3],
              companyId: 2,
              listerIds: [1],
              deadline: "2023-10-30T18:30:00.000Z",
              status: "ACTIVE",
              questionIds: [2, 3],
              startTakingApplicationsAt: "2023-10-03T00:30:00.000Z",
              createdAt: "2023-10-03T17:56:06.161Z",
              updatedAt: "2023-10-23T16:41:20.632Z",
            },
            {
              id: 4,
              role: "Business Analyst",
              positionType: "FULL-TIME",
              minCtc: 500000,
              maxCtc: 850000,
              eligibilityIds: null,
              coursesAllowed: "",
              jobDescription: null,
              jobDescriptionPdfLink: null,
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: null,
              companyId: 7,
              listerIds: [1],
              deadline: "2023-11-05T11:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-11-04T18:30:00.000Z",
              createdAt: "2023-11-05T08:59:35.432Z",
              updatedAt: "2023-11-05T08:59:35.432Z",
            },
            {
              id: 3,
              role: "SDE III",
              positionType: "FULL-TIME",
              minCtc: 10000000,
              maxCtc: 20000000,
              eligibilityIds: null,
              coursesAllowed: "",
              jobDescription: null,
              jobDescriptionPdfLink:
                "https://flashpact-public.s3.ap-south-1.amazonaws.com/listings/job_description/1698138952569__job_description.pdf",
              careerPageApplicationLink: "",
              instituteIds: [1],
              stageIds: null,
              companyId: 5,
              listerIds: [1],
              deadline: "2023-10-23T23:30:00.000Z",
              status: "ACTIVE",
              questionIds: null,
              startTakingApplicationsAt: "2023-10-31T18:30:00.000Z",
              createdAt: "2023-10-24T09:15:53.127Z",
              updatedAt: "2023-11-05T08:58:02.244Z",
            },
          ],
          userDetails: {
            id: 1,
            name: "John Doe",
            dateOfBirth: "1990-01-15",
            gender: "Male",
            password: "",
            email: "roopesh@flashpact.in",
            phone: "12345678901112",
            role: "TPO",
            active: true,
            profilePicture: null,
            permissions: {
              LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
              USER: ["CREATE", "READ", "UPDATE", "DELETE"],
              INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
              COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
              ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
            },
            createdAt: "2023-10-03T11:08:28.614Z",
            updatedAt: "2023-10-22T15:53:17.956Z",
          },
        },
      ],
      stageDetails: [
        {
          id: 3,
          name: "11",
          description: "11",
          scheduledAt: "2023-10-03T20:30:00.000Z",
          venue: "",
          createdAt: "2023-10-03T17:53:25.055Z",
          updatedAt: "2023-10-03T17:53:25.055Z",
        },
      ],
      companyDetails: {
        id: 2,
        name: "Dime Shifter Services",
        site: "www.dimeshifter.com",
        about: "Shifting Dimes",
        listingIds: [1, 1, 1, 1, 1, 1, 1],
        logo: null,
        createdAt: "2023-10-03T17:53:31.708Z",
        updatedAt: "2023-10-23T16:41:20.706Z",
        listingDetails: [
          {
            id: 1,
            role: "Full Stack Engineer",
            positionType: "FULL-TIME",
            minCtc: 400000,
            maxCtc: 750000,
            eligibilityIds: [70],
            coursesAllowed: "B.Tech All Branches",
            jobDescription:
              "<h1>This is a rich job description</h1><h3>Job Responsibilities</h3><h3><br></h3><ul><li>Perform your duties.</li><li>Be punctual.</li><li>Be Professional</li></ul>",
            jobDescriptionPdfLink:
              "https://flashpact-public.s3.ap-south-1.amazonaws.com/listings/job_description/1698078962670__Business_Card.pdf",
            careerPageApplicationLink: "",
            instituteIds: [1],
            stageIds: [3],
            companyId: 2,
            listerIds: [1],
            deadline: "2023-10-30T18:30:00.000Z",
            status: "ACTIVE",
            questionIds: [2, 3],
            startTakingApplicationsAt: "2023-10-03T00:30:00.000Z",
            createdAt: "2023-10-03T17:56:06.161Z",
            updatedAt: "2023-10-23T16:41:20.632Z",
          },
        ],
      },
      listerDetails: [
        {
          id: 1,
          name: "John Doe",
          dateOfBirth: "1990-01-15",
          gender: "Male",
          password: "",
          email: "roopesh@flashpact.in",
          phone: "12345678901112",
          role: "TPO",
          active: true,
          profilePicture: null,
          permissions: {
            LISTING: ["CREATE", "READ", "UPDATE", "DELETE"],
            USER: ["CREATE", "READ", "UPDATE", "DELETE"],
            INSTITUTE: ["CREATE", "READ", "UPDATE", "DELETE"],
            COMPANY: ["CREATE", "READ", "UPDATE", "DELETE"],
            ASPIRANT: ["CREATE", "READ", "UPDATE", "DELETE"],
          },
          createdAt: "2023-10-03T11:08:28.614Z",
          updatedAt: "2023-10-22T15:53:17.956Z",
        },
      ],
      questionDetails: [
        {
          id: 2,
          text: "Can you please provide a response to this question, considering that it's quite long and contains 20 sentences?",
          createdAt: "2023-10-03T17:36:03.379Z",
          updatedAt: "2023-10-03T17:36:03.379Z",
        },
        {
          id: 3,
          text: "This is now some question?\n",
          createdAt: "2023-10-03T17:53:43.971Z",
          updatedAt: "2023-10-03T17:53:43.971Z",
        },
      ],
      eligibilityDetails: [
        {
          id: 70,
          context: "GRADE 10",
          value: 1,
          createdAt: "2023-10-03T17:53:11.289Z",
          updatedAt: "2023-10-03T17:53:11.289Z",
        },
      ],
    },
  },
];

const statisticEvents = [
  {
    id: 7,
    title: "53 ASPIRANTS PLACED!",
    description: "3",
    start: "2023-11-08T18:30:00.000Z",
    end: "2023-11-08T18:30:00.000Z",
    instituteId: 1,
    createdAt: "2023-11-05T13:09:22.186Z",
    updatedAt: "2023-11-05T13:09:34.076Z",
  },
  {
    id: 7,
    title: "58 ASPIRANTS PLACED!",
    description: "3",
    start: "2023-11-10T18:30:00.000Z",
    end: "2023-11-10T18:30:00.000Z",
    instituteId: 1,
    createdAt: "2023-11-05T13:09:22.186Z",
    updatedAt: "2023-11-05T13:09:34.076Z",
  },
  {
    id: 7,
    title: "208 ASPIRANTS PLACED!",
    description: "3",
    start: "2023-11-15T18:30:00.000Z",
    end: "2023-11-15T18:30:00.000Z",
    instituteId: 1,
    createdAt: "2023-11-05T13:09:22.186Z",
    updatedAt: "2023-11-05T13:09:34.076Z",
  },
  {
    id: 7,
    title: "71 ASPIRANTS PLACED!",
    description: "3",
    start: "2023-11-23T18:30:00.000Z",
    end: "2023-11-23T18:30:00.000Z",
    instituteId: 1,
    createdAt: "2023-11-05T13:09:22.186Z",
    updatedAt: "2023-11-05T13:09:34.076Z",
  },
  {
    id: 7,
    title: "65 ASPIRANTS PLACED!",
    description: "3",
    start: "2023-11-04T18:30:00.000Z",
    end: "2023-11-04T18:30:00.000Z",
    instituteId: 1,
    createdAt: "2023-11-05T13:09:22.186Z",
    updatedAt: "2023-11-05T13:09:34.076Z",
  },
  {
    id: 7,
    title: "301 ASPIRANTS PLACED!",
    description: "3",
    start: "2023-11-20T18:30:00.000Z",
    end: "2023-11-20T18:30:00.000Z",
    instituteId: 1,
    createdAt: "2023-11-05T13:09:22.186Z",
    updatedAt: "2023-11-05T13:09:34.076Z",
  },
  {
    id: 7,
    title: "759 ASPIRANTS PLACED!",
    description: "3",
    start: "2023-11-27T18:30:00.000Z",
    end: "2023-11-27T18:30:00.000Z",
    instituteId: 1,
    createdAt: "2023-11-05T13:09:22.186Z",
    updatedAt: "2023-11-05T13:09:34.076Z",
  },
];

const demoData = {
  listings,
  user,
  listing,
  application,
  aspirants,
  calendarEvents,
  statisticEvents,
};

export default demoData;
